import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import ProviderItemGames from "./providers-all-game/ProviderItemGames";
import { useEventListener } from "usehooks-ts";
import ShowContainer from "../mui/ShowContainer";
import LoaderContainer from "../mui/loader_container/LoaderContainer";

export default function ProvidersAllGames() {
  const step = 1;
  const defCountProviders = 3;
  const providers = useSelector((state) => state.games.providers);

  const [displayProviders, setDisplayProviders] = useState([]);
  const [page, setPage] = useState(0);
  const [spinner, setSpinner] = useState(true);
  const [lockPage, setLockPage] = useState(true);

  const scrollPlugRef = useRef();
  const updateScrollTmRef = useRef();

  const providersLength = providers.length;

  const updateScroll = () => {
    const moreGames = displayProviders.length < providers.length;
    setSpinner(moreGames);
    clearTimeout(updateScrollTmRef.current);
    const rect = scrollPlugRef.current?.getBoundingClientRect?.();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    if (!rect) setSpinner(false);

    if (rect.top <= windowHeight && rect.bottom >= 0) {
      updateScrollTmRef.current = setTimeout(() => updateScroll(), 2_000);

      if (moreGames) {
        setPage((prev) => prev + 1);
        setLockPage(true);
      }
    }
  };

  useEffect(() => {
    if (!providersLength) return;
    setDisplayProviders(providers.slice(0, defCountProviders + page * step));
  }, [providersLength, page]);

  useEventListener("scroll", () => {
    if (lockPage) return;
    if (!scrollPlugRef.current || !providersLength) return;

    updateScroll();
  });

  return (
    <div className="games__providers">
      {displayProviders.map((provider) => (
        <ProviderItemGames key={provider.id} provider={provider} setLockPage={setLockPage} />
      ))}

      <ShowContainer condition={!lockPage}>
        <div className="scroll-plug" ref={scrollPlugRef}></div>
      </ShowContainer>
      <LoaderContainer center loader={spinner} />
    </div>
  );
}
